import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../helpers/store/Store";
import { updateTagsCatsList } from "../../helpers/actions/Action";

class MetaPropertiesTagList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      elemTagsCatsList: [],
      reRender: false,
    };
  }

  componentDidUpdate() {
    if (this.props.elemTagsCatsList !== this.state.elemTagsCatsList) {
      this.setState({
        elemTagsCatsList: this.props.elemTagsCatsList,
      });
    }
  }

  handleCheckBoxChange = (elem) => {
    var tempElemTagsCatsList = [];

    tempElemTagsCatsList = this.state.elemTagsCatsList.map(
      (elemTagCat, index) => {
        if (elemTagCat.tag === elem.target.id) {
          return {
            tag: elemTagCat.tag,
            category: elemTagCat.category,
            isSelected: elem.target.checked,
          };
        } else {
          return elemTagCat;
        }
      }
    );
    store.dispatch(updateTagsCatsList(tempElemTagsCatsList));
  };

  handleSelectAllOrNone = (trueOrFalse) => {
    var tempElemTagsCatsList = [];

    tempElemTagsCatsList = this.state.elemTagsCatsList.map(
      (elemTagCat, index) => {
        return {
          tag: elemTagCat.tag,
          category: elemTagCat.category,
          isSelected: trueOrFalse,
        };
      }
    );
    store.dispatch(updateTagsCatsList(tempElemTagsCatsList));
  };

  render() {
    return (
      <div>
        {console.log("showTagCatList =", this.props.showTagsCatList)}
        {this.props.showTagsCatList ? (
          <>
            {/* <br /> */}
            <div className="row justify-content-center align-items-center">
              <h3>Object Table</h3>
            </div>
            {/* <br /> */}
            <div className="row justify-content-center align-items-center">
              <p className="btn-group">
                <button
                  className="btn btn-primary"
                  style={{ marginRight: ".3rem" }}
                  onClick={() => this.handleSelectAllOrNone(true)}
                >
                  Select All
                </button>
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: ".3rem" }}
                  onClick={() => this.handleSelectAllOrNone(false)}
                >
                  Deselect All
                </button>
              </p>
            </div>
            <div className="row justify-content-center align-items-center">
              <table
                className="table table-sm "
                style={{ marginLeft: "auto", marginRight: "auto" }}
              >
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Tag</th>
                    <th style={{ textAlign: "center" }}>Class</th>
                    <th style={{ textAlign: "center" }}>Select</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.elemTagsCatsList.map((elemTagCat, index) => {
                    return (
                      <tr id={index}>
                        <td style={{ textAlign: "center" }}>
                          {elemTagCat.tag}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {elemTagCat.category}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <div
                            className="col-8 p-0"
                            style={{ marginLeft: "auto", marginRight: "auto" }}
                          >
                            <input
                              type="checkbox"
                              id={elemTagCat.tag}
                              defaultChecked={elemTagCat.isSelected}
                              checked={elemTagCat.isSelected}
                              onChange={this.handleCheckBoxChange}
                              style={{
                                marginLeft: "auto",
                                marginRight: "auto",
                              }}
                            />
                            <label htmlFor={elemTagCat.tag}></label>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  elemTagsCatsList: state.metaPropReducer.elemTagsCatsList,
  showTagsCatList: state.metaPropReducer.showElemTagCatList,
});

export default connect(mapStateToProps)(MetaPropertiesTagList);
